import { render, staticRenderFns } from "./dropOffPackageList.vue?vue&type=template&id=929675fc&scoped=true"
import script from "./dropOffPackageList.vue?vue&type=script&lang=js"
export * from "./dropOffPackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929675fc",
  null
  
)

export default component.exports